import React from 'react';
import {Route, RouteProps, useHistory} from 'react-router-dom';
import auth from '../utils/auth';
import Modal from './Modal';

interface IPrivateRoute extends RouteProps {
    component: React.ComponentType<any>;
}

const PrivateRoute = ({component: Component, ...rest}: IPrivateRoute) => {
    const history = useHistory();
    return (
        <Route
            {...rest}
            render={(props) =>
                auth.getToken() !== null ? (
                    <Component {...props} />
                ) : (
                    <Modal
                        open={true}
                        onClose={() => (history.length > 1 ? history.goBack() : history.push('/'))}
                        firstButtonLabel="로그인하기"
                        onClickFirstButton={() => history.push('/auth/login')}
                        secondButtonLabel="다음에 할게요"
                        onClickSecondButton={() => (history.length > 1 ? history.goBack() : history.push('/'))}
                        title="로그인 필요"
                        content={
                            <>
                                로그인하면 쓸 수 있는 기능이에요. <br/>
                                회원이 아니면 로그인 화면에서 가입할 수 있어요.
                            </>
                        }
                    />
                )
            }
        />
    );
};

export default PrivateRoute;
